export default [
  {
    path: '/Main/Dinas/Approval',
    component: () => import('../pages/Verifikasi/VerifikasiAkhir.vue'),
  },
  {
    path: '/Main/Dinas/Approval/:kontrakId/:termin',
    component: () => import('../pages/Verifikasi/VerifikasiAkhir.vue'),
  },
  {
    path: '/Main/Dinas/Penerimaan',
    component: () => import('../pages/Penerimaan/Penerimaan.vue'),
  },
  {
    path: '/Main/Dinas/Penerimaan/:id',
    component: () => import('../pages/Penerimaan/Penerimaan.vue'),
  },
  {
    path: '/Main/Dinas/DaftarPenerimaan',
    component: () => import('../pages/Penerimaan/DaftarPenerimaan.vue'),
  },
  {
    path: '/Main/Balai/Approval',
    component: () => import('../pages/Verifikasi/Verifikasi.vue'),
  },
  {
    path: '/Main/Balai/Approval/:kontrakId/:termin',
    component: () => import('../pages/Verifikasi/Verifikasi.vue'),
  },
  {
    path: '/Main/SPPD/SPPD',
    component: () => import('../pages/SPPD/SPPD/SPPD.vue'),
  },
  {
    path: '/Main/SPPD/SPJ',
    component: () => import('../pages/SPPD/SPJ/SPJ.vue'),
  },
  {
    path: '/Main/SPPD/Sign',
    component: () => import('../pages/SPPD/Sign/Sign.vue'),
  },
  {
    path: '/Main/SPPD/Kalendar',
    component: () => import('../pages/SPPD/Kalendar/Kalendar.vue'),
  },
  {
    path: '/Main/SPPD/Report',
    component: () => import('../pages/SPPD/Report.vue'),
  },
]
